import type { TGrupoIntermediarias } from '@/utils/calculadora-valores-totais/processador-valores-decimal'

export class IntermediariasMapper {
  static transform(grupo: TGrupoIntermediarias[]) {
    if (!grupo?.length) return []
    return grupo.map(({ valor, parcelas, ...rest }) => ({
      ...rest,
      parcelas: parcelas.flatMap(({ data }) => (data ? [{ data, valor }] : [])),
    }))
  }
}
